import { render, staticRenderFns } from "./BackupSetting.vue?vue&type=template&id=009e7995&"
import script from "./BackupSetting.vue?vue&type=script&lang=js&"
export * from "./BackupSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/allianzebpo/public_html/payment/crater/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('009e7995')) {
      api.createRecord('009e7995', component.options)
    } else {
      api.reload('009e7995', component.options)
    }
    module.hot.accept("./BackupSetting.vue?vue&type=template&id=009e7995&", function () {
      api.rerender('009e7995', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/BackupSetting.vue"
export default component.exports